<div class="container">
  <mat-form-field class="full-width">
    <mat-label>{{ placeholder }}</mat-label>

    <mat-chip-list #chipList>
      <mat-chip
        *ngFor="let obj of populatedValue"
        [selectable]="selectable"
        [removable]="removable"
        (removed)="remove(obj)"
        [disabled]="formCtrl?.disabled || formArr?.disabled || false"
      >
        {{ obj.name }} <span *ngIf="obj.templateReference_pop">({{ obj.templateReference_pop.name }})</span>
        <mat-icon matChipRemove *ngIf="removable" style="color: red">cancel</mat-icon>
        <mat-icon matChipTrailingIcon (click)="editClassItem(obj)" style="color: #1976d2">remove_red_eye</mat-icon>
      </mat-chip>

      <input
        #UserInput
        [formControl]="_formCtrl"
        [matAutocomplete]="auto"
        [matChipInputFor]="chipList"
        [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
        [matChipInputAddOnBlur]="addOnBlur"
        (matChipInputTokenEnd)="add($event)"
      />
    </mat-chip-list>
    <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
      <mat-option *ngFor="let obj of filteredData" [value]="obj">
        {{ obj.name }} <span *ngIf="obj.templateReference_pop">({{ obj.templateReference_pop.name }})</span></mat-option
      >
    </mat-autocomplete>
  </mat-form-field>

  <div *ngIf="enabledAdd" class="form-item component-list-remove-btn-item mat-form-field-wrapper">
    <button mat-icon-button color="primary" class="action-btn" (click)="openActCreation()">
      <mat-icon>add</mat-icon>
    </button>
  </div>
</div>
